import { BaseThunk } from 'components/base/base-thunk';
import { FORMAT_DATETIME } from 'utils/constants';
import { TaskHistoryService } from '../task-history.services';
import { RootState } from 'store';
import moment from 'moment';

const taskHistoryService = new TaskHistoryService();

const historyTaskThunkManager = new BaseThunk<ITaskHistory>(taskHistoryService);

export const getAllHistoryTasksThunk = historyTaskThunkManager.getAll<
    ResponseBase<ITaskHistory[]>,
    ITaskHistorySearch
>('/task-history/list', (params, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const historyTaskState = state.historyTask;
    const paginateMetaData = historyTaskState.paginateMetaData;

    const isValidValue = (value: any) => value !== null && value !== undefined && value !== '';
    const isDateKey = (key: string) =>
        [
            'done_date_to',
            'done_date_from',
            'update_at',
            'update_date_from',
            'update_date_to',
        ].includes(key);
    const formatDateValue = (value: any) => moment.utc(value).format(FORMAT_DATETIME.YYYYMMDD2);

    const cleanedFilter = Object.entries(params ?? {}).reduce<ExportTaskSearch>(
        (acc, [key, value]) => {
            if (value === '' || value === undefined) return acc;

            const mappedKey = key === 'tracking_id' ? 'generic_id' : key;

            if (mappedKey === 'status' && value) {
                acc[mappedKey] = [value.toString()];
            } else if (isValidValue(value) || mappedKey === 'delete_at') {
                acc[mappedKey as keyof ExportTaskSearch] = isDateKey(key)
                    ? formatDateValue(value)
                    : value;
            }

            return acc;
        },
        {},
    );

    const sortField =
        historyTaskState.sort?.fieldName === 'tracking_id'
            ? 'generic_id'
            : historyTaskState.sort?.fieldName;

    const sort = historyTaskState.sort?.fieldName
        ? `${sortField}:${historyTaskState.sort.ascending ? 'asc' : 'desc'}`
        : undefined;

    const request: HistoryTaskRequest = {
        page: paginateMetaData.page,
        per_page: paginateMetaData.per_page,
        filter: JSON.stringify(cleanedFilter),
        ...(sort ? { sort } : {}),
    };

    return request;
});
